import React, {useState} from 'react'
import close from '../../assets/icons/close.svg'
import eye from '../../assets/icons/eye.svg'
import at from '../../assets/icons/at.svg'
import Label from '../jadwalguru/Label'
import {useDispatch, useSelector} from 'react-redux'
import {resetField, updateFieldError, updateFieldValue, updateStateSiswa} from '../../features/siswaSlice'
import {useEffect} from 'react'
import KelasSelect from "./KelasSelect";

function DetailFormSiswa() {
    const dispatch = useDispatch()
    const {nama, password, errors, isLoading, isFormEditted} = useSelector(
        (state) => state.siswa
    );

    const [passwordShown, setPasswordShown] = useState(false);
    const [copyForm, setCopyForm] = useState({})

    function handleUnhide() {
        setPasswordShown(passwordShown ? false : true);
    }

    const validateNama = (value) => {
        if (value?.length < 1) {
            return 'Isi nama';
        }
        return '';
    };

    const validatePwd = (value) => {
        if (value.length < 8) {
            return 'Isi password minimal 8 karakter';
        }
        return '';
    };

    function ValidateEmail(mail) {
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
            return ''
        }
        return 'Email tidak valid'
    }

    function validateNoHp(value) {
        if (value?.length < 10) {
            return 'Nomor tidak valid'
        }
        return ''
    }

    const validateAlamat = (value) => {
        if (value?.length < 1) {
            return 'Isi Alamat';
        }
        return '';
    };

    const handleInputChange = (e) => {
        const {name, value} = e.target;
        dispatch(updateFieldValue({field: name, value}));
        let error = '';
        switch (name) {
            case 'nama':
                error = validateNama(value);
                break;
            case 'email':
                error = ValidateEmail(value);
                break;
            case 'password':
                error = validatePwd(value);
                break;
            case 'noHp':
                error = validateNoHp(value);
                break;
            case 'alamat':
                error = validateAlamat(value);
                break;
            default:
                break;
        }
        dispatch(updateFieldError({field: name, error}));

        const preprocessString = (str) => str.replace(/\r/g, '');
        if (
            preprocessString(copyForm[name]) !== value ||
            preprocessString(copyForm[name]) !== preprocessString(value.trim())
        ) {
            dispatch(updateStateSiswa({
                name: 'isFormEditted',
                value: true
            }))
        } else {
            dispatch(updateStateSiswa({
                name: 'isFormEditted',
                value: false
            }))
        }
    };

    const handleResetField = (field) => {
        dispatch(resetField(field));
    };


    useEffect(() => {
        setCopyForm({
            nama: nama,
            password: password,
        })
    }, [isLoading])


    return (
        <div className='form'>
            <div className='nama'>
                <Label className='nama' label='Nama lengkap'/>
                <input
                    type="text"
                    name="nama"
                    value={nama}
                    placeholder='Masukkan nama karyawan'
                    id='nama'
                    onChange={handleInputChange}
                />
                <p className='validator-text'>
                    {errors.nama}
                </p>
                <img src={close} className='at-icon' onClick={() => handleResetField('nama')}/>
            </div>

            <div className='nama'>
                <Label className='nama' label='Password'/>
                <input
                    type={passwordShown ? 'text' : 'password'}
                    name="password"
                    id='password'
                    value={password}
                    placeholder='Password'
                    onChange={handleInputChange}
                />
                <p className='validator-text pwd'>
                    {errors.password}
                </p>
                <img src={eye} className='at-icon' onClick={handleUnhide}/>
            </div>


            <div className='jabatan-gender'>
                <Label className='no-hp' label='Kelas' />
                <KelasSelect />
                <p className='validator-text'>
                    {errors.class_id && errors.class_id}
                </p>
            </div>


        </div>
    )
}

export default DetailFormSiswa